import { connect } from 'react-redux';
import OrderInfo from '../components/OrderInfo';
import {
  getAddedExtraProducts,
  getExtraProductsTotalPrice,
} from '../../../utils/addedExtraProducts';

const mapStateToProps = (state, { form, names }) => ({
  addedExtraProducts: getAddedExtraProducts(form, names)(state),
  totalPrice: getExtraProductsTotalPrice(form)(state),
});

export default connect(mapStateToProps)(OrderInfo);
